/**
 * Shared Tailwind className strings for result-grid header glyphs
 * (EnumHeaderGlyph / JsonHeaderGlyph). Extracted so the two presentational
 * components stay byte-identical in styling: a "declared" glyph is blue, a
 * "native" / "declarable" / "eligible" glyph is muted. Editing a class here
 * intentionally changes both glyph families at once.
 */

/** Blue glyph — the column has user-declared metadata. */
export const GLYPH_DECLARED_CLASS =
  'text-blue-500 text-[10px] font-mono leading-none cursor-pointer hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm';

/** Muted glyph — native / declarable / eligible (no user declaration yet). */
export const GLYPH_MUTED_CLASS =
  'text-muted-foreground text-[10px] font-mono leading-none cursor-pointer hover:underline hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm';
